'use client'

import { type FC } from 'react'
import { useSortBy } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import { useProductSearchContext } from '../../context/productSearchContextValue'
import { useProductSearchClearAllStatus } from '../../hooks/useProductSearchClearAllStatus'

type ProductSearchResultStatusProps = {
  total: number
}

export const ProductSearchResultStatus: FC<ProductSearchResultStatusProps> = ({
  total,
}) => {
  const intl = useIntl()
  const {
    productSearchConfig: { sortByIndexes },
  } = useProductSearchContext()
  const { announceFiltersCleared, isAnnouncementBusy } =
    useProductSearchClearAllStatus()
  const sortBy = useSortBy({ items: sortByIndexes })
  const currentSortLabel = sortBy.options.find(
    ({ value }) => value === sortBy.currentRefinement,
  )?.label
  const totalResultsMessage = intl.formatMessage(
    { id: 'searchResults.label.totalResultsNumber' },
    { total },
  )
  let statusMessage = totalResultsMessage

  if (announceFiltersCleared) {
    statusMessage = `${intl.formatMessage({
      id: 'searchResults.status.filtersCleared',
    })} ${totalResultsMessage}`
  } else if (currentSortLabel) {
    statusMessage = `${currentSortLabel} ${intl.formatMessage({
      id: 'general.selected',
    })} ${totalResultsMessage}`
  }

  return (
    <output
      aria-atomic="true"
      aria-busy={isAnnouncementBusy}
      className="sr-only"
    >
      {statusMessage}
    </output>
  )
}
